import { FileReference } from "../files";
import { Id } from "./id";
import { SortOrder } from "./project-section";
import { z } from "zod";
export const ProjectFeatureStatus = z.enum(["Draft", "ReadyForDevelopment"]);
export const FeaturePublishedStateVisibility = z.enum([
    "Public",
    "WorkspaceMembers",
]);
export const FeaturePublishedState = z.object({
    userId: z.string().optional(),
    lastPublishedAt: z.coerce.date(),
    iterationId: z.string().nullable(),
    hideSupernovaUI: z.boolean(),
    visibility: FeaturePublishedStateVisibility.default("Public"),
});
export const ProjectFeature = z.object({
    createdAt: z.coerce.date(),
    createdByUserId: z.string(),
    description: z.string(),
    id: Id,
    isArchived: z.boolean(),
    name: z.string(),
    projectId: z.string(),
    sectionId: Id.optional(),
    e2bTemplateId: z.string().nullish(),
    e2bIterationId: z.string().nullish(),
    sortOrder: SortOrder.default(0),
    status: ProjectFeatureStatus.default("Draft"),
    updatedAt: z.coerce.date().optional(),
    numberOfIterations: z.number().min(0).default(0),
    numberOfBookmarkedIterations: z.number().min(0).default(0),
    lastReplyTimestamp: z.coerce.date().optional(),
    threadId: z.string().optional(),
    thumbnail: FileReference.optional(),
    publishedState: FeaturePublishedState.optional(),
});
